import { NgModule } from "@angular/core";

import { SidebarModule } from 'primeng/sidebar';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { CommonModule } from "@angular/common";
import { BannerDialogComponent } from './components/banner-dialog/banner-dialog.component';
import { OpportunityDialogComponent } from './components/opportunity-dialog/opportunity-dialog.component';

@NgModule({
    declarations: [
        SidebarComponent,
        BannerDialogComponent,
        OpportunityDialogComponent
    ],
    imports: [
        CommonModule,
        SidebarModule,
        DynamicDialogModule
    ],
    exports: [
        CommonModule,
        SidebarComponent
    ]
})
export class SharedModule {}